"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyForRegion = void 0;
const enums_1 = require("../enums");
const currencyForRegion = (region) => {
    switch (region) {
        case enums_1.Region.SE:
            return enums_1.Currency.SEK;
        case enums_1.Region.EU:
            return enums_1.Currency.EUR;
        case enums_1.Region.UK:
            return enums_1.Currency.GBP;
        case enums_1.Region.US:
        default:
            return enums_1.Currency.USD;
    }
};
exports.currencyForRegion = currencyForRegion;
